import React from "react";
import { useSearchParams } from "react-router-dom";
// components
import Pagination from "@/components/Pagination";
// type
import { TMainPageLayoutV3 } from "../type";


type TMNPG033 = {
    params:{
        searchPagePayload?:any;
        payloadListIsLoading?:boolean;
        [key:string]:any;
    }
}

const MNPG033 = ( props: TMainPageLayoutV3<TMNPG033> ) => {
    console.log("MNPG033.rendered: ", props);

    const [ searchParams, setSearchParams ] = useSearchParams();

    const { params } = props;
    const { searchPagePayload, payloadListIsLoading=true } = params;

    const paginationOnClick = ( event:React.MouseEvent<HTMLDivElement, MouseEvent>, value:number ) => {
        searchParams.set("page", value.toString() );
        setSearchParams(searchParams, { replace:true });
    }

    if ( searchPagePayload?.lastPage > 1 ) {
        return (
            <div className="page-nav-wrap pt-5 text-center">
                <Pagination 
                    currentPage={searchPagePayload?.currentPage} 
                    pageSize={searchPagePayload?.lastPage} 
                    disabled={payloadListIsLoading} 
                    onClick={paginationOnClick}
                    activeClassName="current"
                />
            </div>
        )
    }

    return null;
}

const Component = React.memo(MNPG033, ( prevProps:TMainPageLayoutV3<TMNPG033>, nextProps:TMainPageLayoutV3<TMNPG033> ) => {
    return !(
        prevProps.params?.searchPagePayload !== nextProps.params?.searchPagePayload 
        || prevProps.params?.payloadListIsLoading !== nextProps.params?.payloadListIsLoading
    )
});

export default Component;
